// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import postStatusEntity from './entities/post-status.json';
import postStatusMenu from '../pages/post-status/menu.json';
import postStatusFullForm from '../pages/post-status/forms/full.json';
import postStatusContextForm from '../pages/post-status/forms/context.json';
import postStatusMiniForm from '../pages/post-status/forms/mini.json';
import postStatusLookupForm from '../pages/post-status/forms/lookup.json';
import postStatusTableView from '../pages/post-status/views/table.json';
import postStatusDashboardView from '../pages/post-status/views/dashboard.json';

/** Тип запису «Статус допису» зі сторінками пакета: меню, форми та подання з pages/post-status/. */
export const postStatusDefinition: IRecordTypeDefinition = {
  ...postStatusEntity,
  views: assembleViewSet({
      table: postStatusTableView,
      dashboard: postStatusDashboardView,
  }),
  form: postStatusFullForm,
  forms: { full: postStatusFullForm, context: postStatusContextForm, mini: postStatusMiniForm, lookup: postStatusLookupForm },
  menu: postStatusMenu,
} as IRecordTypeDefinition;
